module.exports = __webpack_public_path__ + "img/BG.c524029c.png";